import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import NumberFormat from "react-number-format";
import {
  getCampaigns_Begin,
  setCampaignsEmpty_Begin,
  selectCampaigns,
  toggleCampaignModal,
  getPaymentPlan_Begin,
  setSelectedCampaign,
  checkIfCustomerHasAddress_Begin,
  checkPersonelInformation_Begin,
  selectPaymentPlan,
  sendSmsOfferValidation,
  memberInstallmentControl,
} from "../../../state/ducks/calculation/index";
import { isShowMemberApplications } from "../../../state/ducks/dashboard/index";
import { alertActions } from "../../../state/ducks/alert/index";
import PaymentPlan from "./PaymentPlan";
import EminevimLoading from "../shared/EminevimLoading";
import LoginPageAlert from "../Login/LoginPageAlert";
import $ from "jquery";

function formKontrol() {
  var tutar = $("#tutar").val();
  var radiobuttonArac = $("#arac-radiobutton").prop('checked')
  var radiobuttonEv = $("#ev-radiobutton").prop('checked')
  var pesinat = $("#pesinat").val();
  var taksit = $("#taksit").val();
  var durum = 1;
  // Tutar boş mu kontrol
  if (!radiobuttonArac && !radiobuttonEv) {

    durum = 0;
    $("#check_hatamesaj").html("Ev yada Araba birini seçiniz");
  }
  else {
    $("#check_hatamesaj").html("");
  }
  if (tutar == "") {
    durum = 0; // Konu Boş
    $("#tutar").parent().addClass("t-error");
    $("#tutar").next().html("<i class='t-icon-error text-danger'></i>");
    $("#tutar_hatamesaj").html("Tutar boş bırakılamaz.");
  } else {
    $("#tutar").parent().removeClass("t-error");
    $("#tutar").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#tutar_hatamesaj").html("");
  }
  // Peşinat boş mu kontrol
  if (pesinat == "") {
    durum = 0; // Mesaj Boş
    $("#pesinat").parent().addClass("t-error");
    $("#pesinat").next().html("<i class='t-icon-error text-danger'></i>");
    $("#pesinat_hatamesaj").html("Peşinat tutarı boş bırakılamaz.");
  } else {
    $("#pesinat").parent().removeClass("t-error");
    $("#pesinat").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#pesinat_hatamesaj").html("");
  };
  // taksit boş mu kontrol
  if (taksit == "") {
    durum = 0; // Mesaj Boş
    $("#taksit").parent().addClass("t-error");
    $("#taksit").next().html("<i class='t-icon-error text-danger'></i>");
    $("#taksit_hatamesaj").html("Taksit tutarı boş bırakılamaz.");
  } else {
    $("#taksit").parent().removeClass("t-error");
    $("#taksit").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#taksit_hatamesaj").html("");
  };
  return durum;
}
const SmartCalculation = ({
  campaigns,
  setCampaignsEmpty_Begin,
  getCampaigns,
  toggleCampaignModal,
  getPaymentPlan_Begin,
  hasAddress,
  hasPersonalInfo,
  history,
  setSelectedCampaign,
  organizasyonTuruId,
  checkIfCustomerHasAddress_Begin,
  checkPersonelInformation_Begin,
  paymentPlan,
  isShowMemberApp,
  showError,
  campaignsError,
}) => {
  const [calculation, setCalculation] = useState({
    totalAmount: "",
    initialAmount: "",
    installment: "",
    homeOrCar: "Ev",
  });
  const [shouldAnimateCard, setShouldAnimateCard] = useState(true);
  const [shouldAnimateCampaigns, setShouldAnimateCampaigns] = useState(false);
  const [isFetchingCampaigns, setIsFetchingCampaigns] = useState(false);
  const [loadingCampaignId, setLoadingCampaignId] = useState(null);
  const [paymentPlanCampaignId, setPaymentPlanCampaignId] = useState(null);
  const campaignsSectionRef = useRef(null);
  const previousCampaignCountRef = useRef(0);

  useEffect(() => {
    setCampaignsEmpty_Begin();
    checkPersonelInformation_Begin();
    checkIfCustomerHasAddress_Begin();

    async function fetchData() {
      const res = await isShowMemberApp();
      const data = await res.data;
      if (data != null && data === false) {
        history.push("/Home/Dashboard");
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const timer = window.setTimeout(() => setShouldAnimateCard(false), 900);
    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    const campaignCount = campaigns?.length || 0;

    if (campaignCount > 0 && previousCampaignCountRef.current === 0) {
      setShouldAnimateCampaigns(true);
      window.setTimeout(() => setShouldAnimateCampaigns(false), 900);

      if (campaignsSectionRef.current) {
        campaignsSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    previousCampaignCountRef.current = campaignCount;
  }, [campaigns]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCalculation({ ...calculation, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formKontrol() == 0) {
      return false;
    }

    setCampaignsEmpty_Begin();
    setPaymentPlanCampaignId(null);

    var orgTuruId =
      calculation.homeOrCar == "Ev"
        ? 2
        : calculation.homeOrCar == "Araç"   
          ? 1
          : 0;
    const query = `orgTutar=${calculation.totalAmount.replace(
      /\./g,
      ""
    )}&pesinatTutar=${calculation.initialAmount === ""
      ? 0
      : calculation.initialAmount.replace(/\./g, "")
      }&taksitTutar=${calculation.installment.replace(
        /\./g,
        ""
      )}&tumKampanyalar=0&pasifMi=false&taksitliPesinat=false&taksitliOrg=false&ozelKampanyalar=0&web=0&iSube=1&orgTuru=${orgTuruId}`;

    setIsFetchingCampaigns(true);
    Promise.resolve(getCampaigns(query)).finally(() => {
      setIsFetchingCampaigns(false);
    });
    $(".kampanya").collapse("hide");
  };

  const getPaymentplan = (campaign) => {

    // $(".kampanya").collapse("hide");
    for (var i = 0; i < campaigns.length; i++) {
      if (campaigns[i].id != campaign.id) {
        $("#kampanya_" + campaigns[i].id).collapse("hide")
      }
    }

    var orgTuruId =
      campaign.organizasyonTuruId == 0 && calculation.homeOrCar == "Ev"
        ? 2
        : campaign.organizasyonTuruId == 0 && calculation.homeOrCar == "Araç"
          ? 1
          : campaign.organizasyonTuruId;
    const query = `firmaId=1&organizasyonTuruId=${orgTuruId}&organizasyonSistemiId=${campaign.organizasyonSistemiId
      }&kampanyaId=${campaign.id}&orgTutar=${campaign.calcOrganizasyonTutari ??
      calculation.totalAmount.toString().replace(/\./g, "")
      }&taksitTutar=${calculation.installment.replace(/\./g, "")}&pesinatTutar=${campaign.organizasyonSistemiId == 3
        ? 0
        : campaign.calcOdenecekPesinat ??
        calculation.initialAmount.replace(/\./g, "")
      }&ciktigiAy=${campaign.calcSonTeslimat
      }&yonetimIskOran=&kampanyaIskOran=&teslimatSonrasiTaksit=&tmpTakTut=${calculation.installment.replace(
        /\./g,
        ""
      )}&takSay=null&btn=null&log=${campaign.logMasterId}`;
    setLoadingCampaignId(campaign.id);
    setPaymentPlanCampaignId(null);
    Promise.resolve(getPaymentPlan_Begin(query, orgTuruId)).finally(() => {
      setLoadingCampaignId(null);
      setPaymentPlanCampaignId(campaign.id);
    });
  };

  const showPaymentDetailsModal = () => {
    toggleCampaignModal(true);
  };

  const showPaymentDetails = (campaign) => {
    getPaymentplan(campaign);
  };

  const submitApprove = (campaign) => {
    if (hasPersonalInfo.kurumsalMi === true) {
      showError(
        "Yeni Üyelik oluşturmak için lütfen Profilim menüsünde yer alan Müşteri Temsilcinizle iletişime geçiniz."
      );
    } else {
      getPaymentplan(campaign);
      setSelectedCampaign(campaign);

      async function fetchData() {
        var orgSistemiId = campaign.organizasyonSistemiId;
        var orgTuruId = organizasyonTuruId;
        var taksitSayisi = paymentPlan.uyelikHareketModelList?.length ?? 0;
        const res = await memberInstallmentControl(
          orgTuruId,
          orgSistemiId,
          taksitSayisi
        );
        if (res === null || res === undefined) {
          if (hasPersonalInfo.bilgiEkle) {
            history.push("/Home/PersonalInfo");
          } else if (hasAddress.sehirId === 0 || hasAddress.adresEkle) {
            history.push("/Home/NewAddress");
          } else {
            sendSmsOfferValidation();
            history.push("/Home/SmsVerification");
          }
        } else {
          await showError(res);
        }
      }
      fetchData();
    }
  };

  const isCampaignPlanLoading = (campaignId) => loadingCampaignId === campaignId;
  const showCampaignPlan = (campaignId) =>
    paymentPlanCampaignId === campaignId && !isCampaignPlanLoading(campaignId);
  const homeOrCarThemeClass =
    calculation.homeOrCar === "Ev"
      ? "t-memberDetail-header--green"
      : "t-memberDetail-header--blue";

  return (
    <div style={{ background: "#ffffff" }}>
      <div className="row" style={{ padding: "3%" }}>
        <div className="col-12">
          <div className="t-memberInfo-pageHeader">
            <h1 className="t-memberInfo-pageTitle">Akıllı Hesap</h1>
            <p className="t-memberInfo-pageSubtitle">
              Ev veya araç hedefinize göre tutar, peşinat ve taksit bilgilerinizi girerek size uygun kampanyaları görüntüleyin.
            </p>
          </div>

          <article
            className={`t-memberInfo-card ${homeOrCarThemeClass}${
              shouldAnimateCard ? " t-memberInfo-card--enter" : ""
            }`}
          >
           

            <div className="t-memberInfo-cardInner">
            <div className="t-memberInfo-cardHeader">
              <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                <i className="t-icon-calculator" aria-hidden="true" />
              </div>

              <div className="t-memberInfo-cardHeaderContent">
                <div className="t-memberInfo-cardTitleRow">
                  <h2 className="t-memberInfo-cardTitle">Hesaplama Yap</h2>
                  <span className="t-memberInfo-typeChip">{calculation.homeOrCar}</span>
                </div>
                <div className="t-memberInfo-cardBadges">
                  <span className="t-memberDetail-headerBadge">Kampanya Hesaplama</span>
                </div>
              </div>
            </div>

            {campaignsError ? (
              <div className="t-eminPayOrder-serviceAlert t-eminPayOrder-serviceAlert--inline">
                <LoginPageAlert
                  type="error"
                  messages={campaignsError}
                  onDismiss={() => setCampaignsEmpty_Begin()}
                />
              </div>
            ) : null}

            <form
              className="t-resetPassword-form t-smartCalculation-form"
              onSubmit={handleSubmit}
              noValidate
            >
              <div className="t-resetPassword-field">
                <span className="t-resetPassword-label">Ne almak istiyorsunuz?</span>
                <div className="t-smartCalculation-choiceGroup">
                  <label
                    className="t-smartCalculation-choiceCard t-smartCalculation-choiceCard--ev"
                    htmlFor="ev-radiobutton"
                  >
                    <input
                      type="radio"
                      id="ev-radiobutton"
                      name="homeOrCar"
                      value="Ev"
                      className="t-smartCalculation-choiceInput"
                      checked={calculation.homeOrCar === "Ev"}
                      onChange={handleChange}
                      required
                    />
                    <span className="t-smartCalculation-choiceIconWrap" aria-hidden="true">
                      <i className="t-icon-home1" />
                    </span>
                    <span className="t-smartCalculation-choiceLabel">Ev</span>
                    <span className="t-smartCalculation-choiceHint">Konut alımı</span>
                  </label>

                  <label
                    className="t-smartCalculation-choiceCard t-smartCalculation-choiceCard--arac"
                    htmlFor="arac-radiobutton"
                  >
                    <input
                      type="radio"
                      id="arac-radiobutton"
                      name="homeOrCar"
                      value="Araç"
                      className="t-smartCalculation-choiceInput"
                      checked={calculation.homeOrCar === "Araç"}
                      onChange={handleChange}
                      required
                    />
                    <span className="t-smartCalculation-choiceIconWrap" aria-hidden="true">
                      <i className="t-icon-truck1" />
                    </span>
                    <span className="t-smartCalculation-choiceLabel">Araç</span>
                    <span className="t-smartCalculation-choiceHint">Araç alımı</span>
                  </label>
                </div>
                <div className="t-icinputHatamesajArea t-resetPassword-error" id="check_hatamesaj" />
              </div>

              <div className="t-resetPassword-field">
                <label htmlFor="tutar" className="t-resetPassword-label">
                  Almak istediğiniz ev veya arabanın tutarını giriniz
                </label>
                <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap">
                  <div>
                    <strong>₺</strong>
                  </div>
                  <NumberFormat
                    id="tutar"
                    placeholder="Tutar"
                    className="sayi"
                    name="totalAmount"
                    required
                    value={calculation.totalAmount}
                    onChange={handleChange}
                    displayType="input"
                    thousandSeparator="."
                    decimalSeparator={false}
                    decimalScale={0}
                    allowNegative={false}
                    // isAllowed={(values) => {
                    //   const { formattedValue, floatValue } = values;
                    //   return formattedValue === "" || floatValue <= 20000000;
                    // }}
                    onBlur={(e) => {
                      const rawValue = parseInt(e.target.value.replace(/\./g, ""), 10);

                      if (!isNaN(rawValue) && rawValue <= 0) {
                        $("#tutar_hatamesaj").html("Minimum değer 1 olmalı!");
                        handleChange({
                          target: {
                            name: "totalAmount",
                            value: "",
                          },
                        });
                      } else {
                        $("#tutar_hatamesaj").html("");
                      }
                    }}
                  />
                  <div />
                </div>
                <div className="t-icinputHatamesajArea t-resetPassword-error" id="tutar_hatamesaj" />
              </div>

              <div className="t-resetPassword-field">
                <label htmlFor="pesinat" className="t-resetPassword-label">
                  Ne kadar peşinat verebilirsiniz?
                </label>
                <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap">
                  <div>
                    <strong>₺</strong>
                  </div>
                  <NumberFormat
                    id="pesinat"
                    placeholder="Peşinat tutarı"
                    className="sayi"
                    name="initialAmount"
                    required
                    value={calculation.initialAmount}
                    onChange={handleChange}
                    displayType="input"
                    thousandSeparator="."
                    decimalSeparator={false}
                    decimalScale={0}
                    allowNegative={false}
                    isAllowed={(values) => {
                      const { formattedValue, floatValue } = values;
                      return formattedValue === "" || floatValue <= 20000000;
                    }}
                    onBlur={(e) => {
                      const rawValue = parseInt(e.target.value.replace(/\./g, ""), 10);

                      if (!isNaN(rawValue) && rawValue < 0) {
                        $("#pesinat_hatamesaj").html("Minimum değer 0 olmalı!");
                        handleChange({
                          target: {
                            name: "initialAmount",
                            value: "",
                          },
                        });
                      } else {
                        $("#pesinat_hatamesaj").html("");
                      }
                    }}
                  />
                  <div />
                </div>
                <div className="t-icinputHatamesajArea t-resetPassword-error" id="pesinat_hatamesaj" />
              </div>

              <div className="t-resetPassword-field">
                <label htmlFor="taksit" className="t-resetPassword-label">
                  Aylık ne kadar taksit ödeyebilirsiniz?
                </label>
                <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap">
                  <div>
                    <strong>₺</strong>
                  </div>
                  <NumberFormat
                    id="taksit"
                    placeholder="Taksit tutarı"
                    className="sayi"
                    name="installment"
                    required
                    value={calculation.installment}
                    onChange={handleChange}
                    displayType="input"
                    thousandSeparator="."
                    decimalSeparator={false}
                    decimalScale={0}
                    allowNegative={false}
                    isAllowed={(values) => {
                      const { formattedValue, floatValue } = values;
                      return formattedValue === "" || floatValue <= 20000000;
                    }}
                    onBlur={(e) => {
                      const rawValue = parseInt(e.target.value.replace(/\./g, ""), 10);

                      if (!isNaN(rawValue) && rawValue <= 0) {
                        $("#taksit_hatamesaj").html("Minimum değer 1 olmalı!");
                        handleChange({
                          target: {
                            name: "installment",
                            value: "",
                          },
                        });
                      } else {
                        $("#taksit_hatamesaj").html("");
                      }
                    }}
                  />
                  <div />
                </div>
                <div className="t-icinputHatamesajArea t-resetPassword-error" id="taksit_hatamesaj" />
              </div>

              <div className="t-resetPassword-actions">
                <button
                  type="submit"
                  className="t-memberInfo-btn t-memberInfo-btn--primary"
                  disabled={isFetchingCampaigns || loadingCampaignId !== null}
                >
                  <span>Kampanyaları Getir</span>
                  <i className="t-icon-arrow-right2" aria-hidden="true" />
                </button>
              </div>

              {isFetchingCampaigns && (
                <div className="t-smartCalculation-formLoading">
                  <EminevimLoading
                    subtext="Kampanyalar hazırlanıyor, lütfen bekleyiniz."
                    compact
                  />
                </div>
              )}
            </form>
            </div>
          </article>

          {campaigns && campaigns.length > 0 && (
            <article
              ref={campaignsSectionRef}
              className={`t-memberInfo-card ${homeOrCarThemeClass} t-smartCalculation-campaignCard${
                shouldAnimateCampaigns ? " t-memberInfo-card--enter" : ""
              }`}
            >
             

              <div className="t-memberInfo-cardInner">
              <div className="t-memberInfo-cardHeader">
                <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                  <i className="t-icon-gift" aria-hidden="true" />
                </div>

                <div className="t-memberInfo-cardHeaderContent">
                  <h2 className="t-memberInfo-cardTitle">Size Uygun Kampanyalar</h2>
                  <div className="t-memberInfo-cardBadges">
                    <span className="t-memberDetail-headerBadge">
                      {campaigns.length} teklif
                    </span>
                  </div>
                </div>
              </div>

              <div className="t-smartCalculation-campaignList accordion" id="teslimatOnce">
                {campaigns.map((item) => (
                  <div className="t-smartCalculation-campaignItem" key={item.id}>
                    <button
                      type="button"
                      className="t-smartCalculation-campaignHeader kampanya"
                      data-toggle="collapse"
                      data-target={`#kampanya_${item.id}`}
                      onClick={() => showPaymentDetails(item)}
                      aria-expanded="false"
                      aria-controls={`kampanya_${item.id}`}
                      disabled={loadingCampaignId !== null && loadingCampaignId !== item.id}
                    >
                      <span className="t-smartCalculation-campaignCategory">Kampanya Teklifi</span>
                      <span className="t-smartCalculation-campaignTitle">{item.formKampanyaAdi}</span>
                      <i className="t-icon-keyboard_arrow_down t-smartCalculation-campaignChevron" aria-hidden="true" />
                    </button>

                    <div
                      id={`kampanya_${item.id}`}
                      className="collapse kampanya t-smartCalculation-campaignBody"
                      data-parent="#teslimatOnce"
                    >
                      {isCampaignPlanLoading(item.id) ? (
                        <div className="t-smartCalculation-campaignLoading">
                          <EminevimLoading
                            subtext="Ödeme planı hazırlanıyor, lütfen bekleyiniz."
                            compact
                          />
                        </div>
                      ) : showCampaignPlan(item.id) ? (
                        <>
                          <div className="t-smartCalculation-offerTableWrap">
                            <table className="t-smartCalculation-offerTable">
                              <thead>
                                <tr>
                                  <th colSpan={2}>Teklif özetimiz aşağıdaki gibidir.</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{calculation.homeOrCar} Değeri</td>
                                  <td>
                                    <NumberFormat
                                      value={paymentPlan?.uyelik?.orgTutar ?? null}
                                      displayType="text"
                                      thousandSeparator="."
                                      decimalSeparator=","
                                      prefix="₺ "
                                      decimalScale={2}
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>Ödeme Peşinatı</td>
                                  <td>
                                    <NumberFormat
                                      value={paymentPlan?.uyelik?.pesinatTutar ?? null}
                                      displayType="text"
                                      thousandSeparator="."
                                      decimalSeparator=","
                                      prefix="₺ "
                                      decimalScale={2}
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>Organizasyon Ücreti</td>
                                  <td>
                                    <NumberFormat
                                      value={paymentPlan?.uyelik?.orgUcretiKdvDahil ?? null}
                                      displayType="text"
                                      thousandSeparator="."
                                      decimalSeparator=","
                                      prefix="₺ "
                                      decimalScale={2}
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>Toplam Maliyet</td>
                                  <td>
                                    <NumberFormat
                                      value={paymentPlan?.uyelik?.toplamMaliyet ?? null}
                                      displayType="text"
                                      thousandSeparator="."
                                      decimalSeparator=","
                                      prefix="₺ "
                                      decimalScale={2}
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>Taksit Sayısı</td>
                                  <td>{paymentPlan?.uyelikHareketModelList?.length ?? 0}</td>
                                </tr>
                                {item.organizasyonSistemiId == 1 && (
                                  <tr>
                                    <td>
                                      Teslimat Dönemi{" "}
                                      <i
                                        className="fa fa-info-circle"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        title="Bu kampanyayı seçmeniz durumunda teslimatınızı alacağınız son ay"
                                      />
                                    </td>
                                    <td>
                                      {item.ilkTeslimDonem}-{item.calcSonTeslimat}
                                    </td>
                                  </tr>
                                )}
                                {item.organizasyonSistemiId == 2 && (
                                  <tr>
                                    <td>Teslimat Tarihi</td>
                                    <td>{paymentPlan?.uyelik?.ilkTeslimTarihiDisplay}</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>

                          <div className="t-smartCalculation-campaignActions">
                            <button
                              type="button"
                              className="t-memberInfo-btn t-memberInfo-btn--secondary"
                              onClick={() => showPaymentDetailsModal()}
                            >
                              <span>Taksit Detayı</span>
                              <i className="t-icon-arrow-right2" aria-hidden="true" />
                            </button>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>
              </div>
            </article>
          )}
        </div>
      </div>

      <PaymentPlan />
    </div>
  );
};

const mapStateToProps = (state) => ({
  campaigns: selectCampaigns(state),
  campaignsError: state.calculation.campaignsError,
  hasAddress: state.calculation.hasAddress,
  hasPersonalInfo: state.calculation.hasPersonalInfo,
  selectedCampaign: state.calculation.selectedCampaign,
  organizasyonTuruId: state.calculation.orgTuruId,
  paymentPlan: selectPaymentPlan(state),
});

const mapDispatchToProps = (dispatch) => ({
  getCampaigns: (query) => dispatch(getCampaigns_Begin(query)),
  setCampaignsEmpty_Begin: () => dispatch(setCampaignsEmpty_Begin()),
  toggleCampaignModal: (isOpen) => dispatch(toggleCampaignModal(isOpen)),
  getPaymentPlan_Begin: (query, orgTuruId) =>
    dispatch(getPaymentPlan_Begin(query, orgTuruId)),
  setSelectedCampaign: (campaign) => dispatch(setSelectedCampaign(campaign)),
  checkIfCustomerHasAddress_Begin: () =>
    dispatch(checkIfCustomerHasAddress_Begin()),
  checkPersonelInformation_Begin: () =>
    dispatch(checkPersonelInformation_Begin()),
  isShowMemberApp: () => dispatch(isShowMemberApplications()),
  showError: (message) => dispatch(alertActions.showError(message)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SmartCalculation);
